import { useHandleFormSubmission } from '@ecomm/promotions-hooks'

import { LeadCaptureForm } from './LeadCaptureForm'
import { LeadCaptureSuccess } from './LeadCaptureSuccess'

export function LeadCapture() {
  const { isFormSubmitted } = useHandleFormSubmission()
  return (
    <div className="px-4 pb-4 lg:p-0">
      {!isFormSubmitted ? <LeadCaptureForm /> : <LeadCaptureSuccess />}
    </div>
  )
}
